
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";

const NextArrow = ({ onClick, style, className }) => {
  return (
    <button className={className} onClick={onClick} style={{ ...style, display: "block" }}>
      <FiChevronRight />
    </button>
  );
};
const PrevArrow = ({ onClick, style, className }) => {
  return (
    <button onClick={onClick} className={className} style={{ ...style }}>
      <FiChevronLeft />
    </button>
  );
};



export const react_slick_settings = {
  infinite: true,
  speed: 1500,
  slidesToShow: 1,
  slidesToScroll: 1,
  initialSlide: 0,
  autoplay: true,
  autoplaySpeed: 10000,
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        arrows: false,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 1,
        arrows: false,
        dots: true
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true
      }
    }
  ]
};
